import { observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'

import {
   isAPIInitial,
   isAPIFetching
} from '@flowwai-frontend/shared/api-common'
import { FullScreenLoader } from '@flowwai-frontend/shared/common-components'

import useOLAMapStringSearch from '../../hooks/useOLAMapStringSearch'
import { MapCoordinates } from '../../types'

interface Props {
   addressToCenterMapOnLoad?: string
   children: (addressCoordinates: MapCoordinates | null) => React.ReactElement
}

const MapsAddressLocator = (props: Props): React.ReactElement => {
   const { addressToCenterMapOnLoad } = props

   const [
      addressCoordinates,
      setAddressCoOrdinates
   ] = useState<MapCoordinates | null>(null)

   const olaMapStringSearchAPI = useOLAMapStringSearch()

   const fetchAddressCoOrdinates = (): void => {
      if (!addressToCenterMapOnLoad) return

      olaMapStringSearchAPI.triggerAPI({
         suggestString: addressToCenterMapOnLoad,
         onSuccess: setAddressCoOrdinates
      })
   }

   useEffect(fetchAddressCoOrdinates, [])

   if (!addressToCenterMapOnLoad)
      return <>{props.children(addressCoordinates)}</>

   const isApiFetching = addressToCenterMapOnLoad
      ? isAPIFetching(olaMapStringSearchAPI.apiStatus) ||
        isAPIInitial(olaMapStringSearchAPI.apiStatus)
      : false

   return isApiFetching ? (
      <FullScreenLoader />
   ) : (
      <>{props.children(addressCoordinates)}</>
   )
}

export default observer(MapsAddressLocator)
